const router = {
  mode: 'history',
  // base: '/',
  // base: "/datangholdings/",
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../pages/home/index')
  },
  {
    path: '/contain',
    name: 'contain',
    component: () => import('../pages/home/contain'),
    children: [{
      path: '/application',
      name: 'application',
      component: () => import('../pages/application/index'),
      children: [{
        path: '/',
        redirect: '/applicationCase1'
      },
      {
        path: '/applicationCase1',
        name: 'applicationCase1',
        component: () => import('../pages/application/case1')
      },
      {
        path: '/applicationCase2',
        name: 'applicationCase2',
        component: () => import('../pages/application/case2')
      },
      {
        path: '/applicationCase3',
        name: 'applicationCase3',
        component: () => import('../pages/application/case3')
      },
      {
        path: '/applicationCase4',
        name: 'applicationCase4',
        component: () => import('../pages/application/case4')
      }
      ]
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('../pages/product/index'),
      children: [{
        path: '/',
        redirect: '/productSoftware'
      },
      {
        path: '/productSoftware',
        name: 'productSoftware',
        component: () => import('../pages/product/software')
      },
      {
        path: '/productHardware',
        name: 'productHardware',
        component: () => import('../pages/product/hardware')
      }
      ]
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('../pages/news/index'),
      children: [{
        path: '/',
        redirect: '/newsDetails1'
      },
      {
        path: '/newsDetails1',
        name: 'newsDetails1',
        component: () => import('../pages/news/details01')
      },
      {
        path: '/newsDetails2',
        name: 'newsDetails2',
        component: () => import('../pages/news/details02')
      },
      {
        path: '/newsDetails3',
        name: 'newsDetails3',
        component: () => import('../pages/news/details03')
      },
      {
        path: '/newsDetails4',
        name: 'newsDetails4',
        component: () => import('../pages/news/details04')
      },
      {
        path: '/newsDetails5',
        name: 'newsDetails5',
        component: () => import('../pages/news/details05')
      },
      {
        path: '/newsDetails6',
        name: 'newsDetails6',
        component: () => import('../pages/news/details06')
      },
      {
        path: '/newsDetails7',
        name: 'newsDetails7',
        component: () => import('../pages/news/details07')
      },
      {
        path: '/newsDetails8',
        name: 'newsDetails8',
        component: () => import('../pages/news/details08')
      }
      ]
    }
    ]
  }, {
    path: '/registChn',
    redirect: '/home',
    component: () => import('../pages/Index'),
    children: [{
      path: '/domainserverlist',
      name: 'domainlist',
      component: () => import('../pages/domainserver/list'),
      meta: {
        title: ' .CHN服务列表',
        requireAuth: true,
        isTwoNav: true
      }
    }, {
      path: '/order',
      component: () => import('../pages/expense/order.vue'),
      name: 'order',
      meta: {
        // title:'审核信息',
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/order_detail',
      component: () => import('../pages/expense/order_detail.vue'),
      name: 'order_detail',
      meta: {
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/auditRecords',
      name: 'auditRecords',
      component: () => import('../pages/domainserver/auditRecords'),
      meta: {
        title: '审核记录',
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/auditModelInfo',
      name: 'auditModelInfo',
      component: () => import('../pages/domainserver/auditModelInfo'),
      meta: {
        title: '审核模板信息',
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/domainservermessagelist',
      name: 'messagelist',
      component: () => import('../pages/domainserver/messagelist'),
      meta: {
        title: ' .CHN信息模板',
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/domainserverbasedetail',
      name: 'basedetail',
      component: () => import('../pages/domainserver/domaindetail'),
      meta: {
        title: ' .CHN基本信息',
        requireAuth: true
        // isTwoNav:true,
      }
    },
    {
      path: '/domainserverxagddetail',
      name: 'basedetail',
      component: () => import('../pages/domainserver/xagddetail'),
      meta: {
        title: '详情西安工大',
        requireAuth: true
        // isTwoNav:true,
      }
    },
    {
      path: '/domainservercreatemodel',
      name: 'createmodellist',
      component: () => import('../pages/domainserver/createmodel'),
      meta: {
        title: '创建模板',
        requireAuth: true
      }
    },
    {
      path: '/updateModel',
      name: 'updateModel',
      component: () => import('../pages/domainserver/updatemodel'),
      meta: {
        title: '持有者过户',
        requireAuth: true
      }
    },
    {
      path: '/domainserveractioncodelist',
      name: 'actioncodelist',
      component: () => import('../pages/domainserver/actioncode'),
      meta: {
        title: '操作记录'
      }
    },
    {
      path: '/domainserveremailedtify',
      name: 'emailedtifylist',
      component: () => import('../pages/domainserver/emailedtify'),
      meta: {
        title: '邮箱验证',
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/domainservertruenameVerify',
      name: 'truenameVerifyList',
      component: () => import('../pages/domainserver/truenameVerify'),
      meta: {
        title: '认证信息',
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/domainservercreateVetify',
      name: 'createVetify',
      component: () => import('../pages/domainserver/createVerify'),
      meta: {
        title: '添加认证',
        requireAuth: true
      }
    },
    {
      path: '/domainserver_emailedtifysuccess',
      name: 'emailedtifysuccess',
      component: () => import('../pages/domainserver/emailsuccess'),
      meta: {
        title: '邮箱验证成功'
        // requireAuth: true
      }
    },
    {
      path: '/domainservermanger',
      name: 'domainmanger',
      component: () => import('../pages/domainserver/actionmanager'),
      meta: {
        title: ' .CHN操作管理',
        requireAuth: true
      }
    },
    {
      path: '/domainserverpay',
      name: 'domainpay',
      component: () => import('../pages/domainserver/actionnextpay'),
      meta: {
        title: ' .CHN操作续费',
        requireAuth: true
      }
    },
    {
      path: '/domainanalysislist',
      name: 'analysislist',
      component: () => import('../pages/domainanalysis/list'),
      meta: {
        title: ' .CHN解析列表',
        requireAuth: true
      }
    },
    {
      path: '/domainanalysisanalysissetup',
      name: 'analysissetup',
      component: () => import('../pages/domainanalysis/analysissetup'),
      meta: {
        title: ' .CHN解析列表',
        requireAuth: true
      }
    },
    {
      path: '/domainanalysisdetail',
      name: 'analysisdetail',
      component: () => import('../pages/domainanalysis/detail'),
      meta: {
        title: ' .CHN产品详情',
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/domainanalysisanalysisrecode',
      name: 'analysisrecode',
      component: () => import('../pages/domainanalysis/analysisrecode'),
      meta: {
        title: ' .CHN解析日志',
        requireAuth: true
      }
    },
    {
      path: '/shoppingcarorder',
      name: 'shoppingcarorder',
      component: () => import('../pages/shoppingcar/order'),
      meta: {
        title: '购物车订单',
        requireAuth: true
      }
    }, {
      path: '/shoppingcarorderPay',
      name: 'shoppingcarorderPay',
      component: () => import('../pages/shoppingcar/orderPay'),
      meta: {
        title: '订单支付',
        requireAuth: true
      }
    },
    {
      path: '/shoppingcarxagdorder',
      name: 'shoppingcarxagdorder',
      component: () => import('../pages/shoppingcar/xagdorder'),
      meta: {
        title: '西工大购物车订单',
        requireAuth: true
      }
    },
    {
      path: '/shoppingcarpayxagd',
      name: 'shoppingcarpayxagd',
      component: () => import('../pages/shoppingcar/payxagd'),
      meta: {
        title: '西工大提交订单',
        requireAuth: true
      }
    },

    {
      path: '/shoppingcarrenewal',
      name: 'shoppingcarrenewal',
      component: () => import('../pages/shoppingcar/renewal'),
      meta: {
        title: '续费订单',
        requireAuth: true
      }
    },
    {
      path: '/shoppingcarsuccess',
      name: 'ordersuccess',
      component: () => import('../pages/shoppingcar/paysuccess'),
      meta: {
        title: '支付成功',
        requireAuth: true
      }
    },
    {
      path: '/shoppingcarsuccessxagd',
      name: 'ordersuccessxagd',
      component: () => import('../pages/shoppingcar/paysuccessxagd'),
      meta: {
        title: '支付失败西安工大',
        requireAuth: true
      }
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: () => import('../pages/user'),
      redirect: '/setting',
      meta: {
        title: '基本信息',
        requireAuth: true
      },
      children: [{
        path: '/usertotalPrice',
        name: 'usertotalPrice',
        component: () => import('../pages/user/totalPrice.vue'),
        meta: {
          title: '我的余额',
          requireAuth: true
        }
      },
      {
        path: '/userTrip',
        name: 'userTrip',
        component: () => import('../pages/user/trip.vue'),
        meta: {
          title: '我的账单',
          requireAuth: true
        }
      },
      {
        path: '/setting',
        component: () => import('../pages/user/setting.vue'),
        name: 'setting',
        meta: {
          requireAuth: true
        }
      }
      ]
    },
    {
      path: '/useridentification',
      name: 'usersidentification',
      component: () => import('../pages/user/identification'),
      meta: {
        title: '实名认证',
        requireAuth: true
      }
    },
    {
      path: '/useridentificationcheck',
      name: 'usersidentificationchecking',
      component: () => import('../pages/user/indentifychecking'),
      meta: {
        title: '正在审核',
        requireAuth: true
      }
    },
    {
      path: '/userchecked',
      name: 'checkedpass',
      component: () => import('../pages/user/checkingsuccess'),
      meta: {
        title: '审核信息',
        requireAuth: true
      }
    },

    {
      path: '/invoice',
      component: () => import('../pages/invoice/invoice.vue'),
      name: 'invoice',
      meta: {
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/domainclause',
      name: 'domainclause',
      component: () => import('../pages/user/clause'),
      meta: {
        title: '服务条款'
      }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import('../pages/user/agreement.vue')
    },
      // 索要发票--信息
    {
      path: '/issueInvoice',
      component: () => import('../pages/invoice/issueInvoice.vue'),
      name: 'issueInvoice',
      meta: {
        requireAuth: true
      }
    },
      // 索要发票--完成
    {
      path: '/invoiceComplete',
      component: () => import('../pages/invoice/invoiceComplete'),
      name: 'invoiceComplete',
      meta: {
        requireAuth: true
      }
    },
      // 发票列表--详情
    {
      path: '/invoice_detail',
      component: () => import('../pages/invoice/detail.vue'),
      name: 'invoice_detail',
      meta: {
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/invoice_list',
      component: () => import('../pages/invoice/list.vue'),
      name: 'invoice_list',
      meta: {
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/invoice_information',
      component: () => import('../pages/invoice/information.vue'),
      name: 'invoice_information',
      meta: {
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/invoice_address',
      component: () => import('../pages/invoice/address.vue'),
      name: 'invoice_address',
      meta: {
        requireAuth: true,
        isTwoNav: true
      }
    },
    {
      path: '/message',
      component: () => import('../pages/message/index.vue'),
      name: 'message',
      meta: {
        requireAuth: true
      }
    },

    {
      path: '/revisePwd',
      component: () => import('../pages/user/revisePwd.vue'),
      name: 'revisePwd',
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/authenticate',
      component: () => import('../pages/user/authenticate.vue'),
      name: 'authenticate',
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/revisePhone',
      component: () => import('../pages/user/revisePhone.vue'),
      name: 'revisePhone',
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/revisePhoneSuccess',
      component: () => import('../pages/user/revisePhoneSuccess.vue'),
      name: 'revisePhoneSuccess',
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/verifyPhone',
      component: () => import('../pages/user/verifyPhone.vue'),
      name: 'verifyPhone',
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/verifyIdentity',
      component: () => import('../pages/user/verifyPhone.vue'),
      name: 'verifyIdentity',
      meta: {
        requireAuth: true
      }
    },

      // 申诉
    {
      path: '/appealList',
      component: () => import('../pages/appeal/index'),
      name: 'appealList',
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/addappeal',
      component: () => import('../pages/appeal/add'),
      name: 'addappeal',
      meta: {
        requireAuth: true
      }
    }
    ]
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/HomeSearch',
    component: () => import('../pages/home/newHome/index.vue'),
    meta: {
      title: '首页'
    },
    children: [{
      path: '/whois',
      name: 'whois',
      component: () => import('../pages/home/whois.vue'),
      meta: {
        title: ' .CHN注册信息'
      }
    },
    {
      path: '/networkSetting',
      name: 'networkSetting',
      component: () => import('../pages/home/newHome/networkSettings'),
      meta: {
        title: 'networkSetting'
      }
    },
    {
      path: '/article',
      name: 'article',
      redirect: '/article01',
      component: () => import('../pages/article/nav.vue'),
      meta: {
        title: '文章'
      },
      children: [{
        path: '/article01',
        name: 'article01',
        component: () => import('../pages/article/article01.vue')
      },
      {
        path: '/article02',
        name: 'article02',
        component: () => import('../pages/article/article02.vue')
      },
      {
        path: '/article03',
        name: 'article03',
        component: () => import('../pages/article/article03.vue')
      },
      {
        path: '/article04',
        name: 'article04',
        component: () => import('../pages/article/article04.vue')
      },
      {
        path: '/article05',
        name: 'article05',
        component: () => import('../pages/article/article05.vue')
      },
      {
        path: '/article06',
        name: 'article06',
        component: () => import('../pages/article/article06.vue')
      },
      {
        path: '/article07',
        name: 'article07',
        component: () => import('../pages/article/article07.vue')
      },
      {
        path: '/article08',
        name: 'article08',
        component: () => import('../pages/article/article08.vue')
      },
      {
        path: '/article09',
        name: 'article09',
        component: () => import('../pages/article/article09.vue')
      },
      {
        path: '/article10',
        name: 'article10',
        component: () => import('../pages/article/article10.vue')
      },
      {
        path: '/article11',
        name: 'article11',
        component: () => import('../pages/article/article11.vue')
      }
        // {
        //   path: "/article12",
        //   name: "article12",
        //   component: article12
        // }
      ]
    },
    {
      path: '/download/:id',
      name: 'download',
      component: () => import('../pages/home/patent/download')
    },
    {
      path: '/news',
      name: 'newsContent',
      redirect: '/newDetail01',
      component: () => import('../pages/news/nav.vue'),
      meta: {
        title: '文章'
      },
      children: [{
        path: '/newDetail01',
        name: 'newDetail01',
        component: () => import('../pages/news/newDetail01.vue')
      },
      {
        path: '/newDetail02',
        name: 'newDetail02',
        component: () => import('../pages/news/newDetail02.vue')
      },
      {
        path: '/newDetail03',
        name: 'newDetail03',
        component: () => import('../pages/news/newDetail03.vue')
      },
        // {
        //   path: "/newDetail04",
        //   name: "newDetail04",
        //   component: newDetail04
        // },
      {
        path: '/newDetail04',
        name: 'newDetail05',
        component: () => import('../pages/news/newDetail05.vue')
      },
        // {
        //   path: "/newDetail06",
        //   name: "newDetail06",
        //   component: newDetail06
        // },
      {
        path: '/newDetail05',
        name: 'newDetail07',
        component: () => import('../pages/news/newDetail07.vue')
      },
      {
        path: '/newDetail06',
        name: 'newDetail08',
        component: () => import('../pages/news/newDetail08.vue')
      },
        // {
        //   path: "/newDetail09",
        //   name: "newDetail09",
        //   component: newDetail09
        // },
      {
        path: '/newDetail07',
        name: 'newDetail10',
        component: () => import('../pages/news/newDetail10.vue')
      },
      {
        path: '/newDetail08',
        name: 'newDetail11',
        component: () => import('../pages/news/newDetail11.vue')
      }
      ]
    }
    ]
  },
  // {
  //   path: '/config',
  //   name: 'config-dns',
  //   beforeEnter (to, from, next) {
  //     // window.location.href = 'http://192.168.88.116:8080/chnapi/config/dns'
  //     // next(false) // 阻止继续执行路由的默认行为
  //     fetch('http://192.168.88.116:8080/chnapi/config/dns')
  //       .then(response => response.text())
  //       .then(data => {
  //         // 动态创建 HTML 内容
  //         const htmlContent = `
  //         <!DOCTYPE html>
  //         <html lang="en">
  //         <head>
  //           <meta charset="UTF-8">
  //           <meta name="viewport" content="width=device-width, initial-scale=1.0">
  //           <title>Config DNS</title>
  //         </head>
  //         <body>
  //           <h1>DNS Configurations</h1>
  //           <p>Here is the DNS configuration data:</p>
  //           <pre id="dns-data">Loading...</pre>
  //         </body>
  //         </html>
  //       `

  //         // 创建 Blob 对象
  //         const blob = new Blob([htmlContent], { type: 'text/html' })
  //         const url = URL.createObjectURL(blob)
  //         // 打开新窗口并显示生成的 HTML
  //         console.log('sssssssss', url)

  //         window.open(url)
  //         // alert(data) // 弹出字符串数据
  //         // console.log(data) // 或者在控制台输出
  //         next(false) // 阻止页面跳转
  //       })
  //       .catch(error => {
  //         console.error('Error fetching data:', error)
  //         next(false)
  //       })
  //   }
  // },
  // {
  //   path: '/config/dns',
  //   name: 'ConfigDns',
  //   component: () => import('../pages/config/dns.vue'),
  //   meta: {
  //     title: ''
  //   }
  // },
  {
    path: '/HomeSearch',
    name: 'HomeSearch',
    component: () => import('../pages/home/newHome/search.vue'),
    meta: {
      title: ' .CHN查询'
    }
  },
  {
    path: '/BrowserDownload',
    name: 'BrowserDownload',
    component: () => import('../pages/home/newHome/BrowserDownload.vue'),
    meta: {
      title: '.CHN专用浏览器下载'
    }
  },
  {
    path: '/HomeInternet',
    name: 'HomeInternet',
    component: () => import('../pages/home/internet/index.vue'),
    meta: {
      title: '未来网络'
    }
  },
  {
    path: '/HomePatent',
    name: 'HomePatent',
    component: () => import('../pages/home/patent/index.vue'),
    meta: {
      title: '专利标准'
    }
  },
  {
    path: '/HomeHardware',
    name: 'HomeHardware',
    component: () => import('../pages/home/Hardware/index.vue'),
    meta: {
      title: '硬件购买'
    }
  },
  {
    path: '/HomeUsermanual',
    name: 'HomeUsermanual',
    component: () => import('../pages/home/Usermanual/index.vue'),
    meta: {
      title: '使用手册'
    }
  },
  {
    path: '/HomeHelp',
    name: 'HomeHelp',
    component: () => import('../pages/home/HomeHelp/index.vue'),
    meta: {
      title: '帮助支持'
    }
  },
  {
    path: '/searchResults',
    name: 'searchResults',
    component: () => import('../pages/home/newHome/searchResults'),
    meta: {
      title: ' .CHN查询结果'
      // requireAuth: true
    }
  },
  {
    path: '/domainList',
    name: 'domainList',
    component: () => import('../pages/home/domainList'),
    meta: {
      title: ' .CHN清单',
      requireAuth: true
    }
  },
  {
    path: '/newsDetails01',
    name: 'newsDetails01',
    component: () => import('../pages/home/news/newsDetails01'),
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/newsDetails02',
    name: 'newsDetails02',
    component: () => import('../pages/home/news/newsDetails02'),
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/newsDetails03',
    name: 'newsDetails03',
    component: () => import('../pages/home/news/newsDetails03'),
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/newsDetails04',
    name: 'newsDetails04',
    component: () => import('../pages/home/news/newsDetails04'),
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/newsDetails05',
    name: 'newsDetails05',
    component: () => import('../pages/home/news/newsDetails05'),
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/newsDetails06',
    name: 'newsDetails06',
    component: () => import('../pages/home/news/newsDetails06'),
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/newsDetails07',
    name: 'newsDetails07',
    component: () => import('../pages/home/news/newsDetails07'),
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/newsDetails08',
    name: 'newsDetails08',
    component: () => import('../pages/home/news/newsDetails08'),
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/clause',
    name: 'clause',
    component: () => import('../pages/user/clause'),
    meta: {
      title: '服务条款'
    }
  },
  {
    path: '/statement',
    name: 'statement',
    component: () => import('../pages/home/statement'),
    meta: {
      title: '声明'
    }
  },
    // {
    //   path: "/pdf/:pdfUrl",
    //   name: "pdf",
    //   component: () => import("../components/pdf/pdfBox.vue")
    // }
  {
    path: '/pdf/img',
    name: 'pdf',
    component: () => import('../components/pdf/img.vue')
  }, {
    path: '/sjzsearch',
    name: 'sjzsearch',
    component: () => import('../pages/home/sjzSearch.vue'),
    meta: {
      title: '十进制搜索'
    }
  }
    // {
    //   path:'/login',
    //   name:'login',
    //   component: login,
    //   meta: {
    //     title:'登录',
    //   }
    // },
    // {
    //   path: '/register',
    //   component: register,
    // },
    // {
    //   path: '/findPwd',
    //   component: findPwd,
    // },
  ]
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js